var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_119_35",
    "data-name": "Component 119 \\u2013 35",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Number_style_",
    "data-name": "Number (style)",
    width: 28,
    height: 28,
    rx: 6,
    fill: "#fff",
    stroke: "#f0f0f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_edit_light",
    "data-name": "UI icon/edit/light",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M1,18.282a1,1,0,0,1-.977-1.2l1.061-5.3a.99.99,0,0,1,.274-.51L11.747.878a3,3,0,0,1,4.243,0L17.4,2.293a3,3,0,0,1,0,4.243L7.011,16.928A1,1,0,0,1,6.5,17.2l-5.3,1.06A1.022,1.022,0,0,1,1,18.282ZM10.332,5.121h0l-7.349,7.35-.707,3.535L5.81,15.3l7.35-7.35L10.332,5.121ZM13.868,2a.994.994,0,0,0-.707.293L11.747,3.707l2.828,2.829,1.415-1.415a1,1,0,0,0,0-1.414L14.574,2.293A.991.991,0,0,0,13.868,2Z",
    fill: "#6f767e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.d7cc9b19816e408f5cca7b3eae7b587b.svg";
export { ForwardRef as ReactComponent };